import { render, staticRenderFns } from "./register.page.vue?vue&type=template&id=49c69dee&scoped=true&"
import script from "./register.page.vue?vue&type=script&lang=js&"
export * from "./register.page.vue?vue&type=script&lang=js&"
import style0 from "./register.page.vue?vue&type=style&index=0&id=49c69dee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c69dee",
  null
  
)

export default component.exports